var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollUpArr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 385,
    height: 448,
    viewBox: "0 0 385 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.675 9.375C202.175 -3.125 181.875 -3.125 169.375 9.375L9.375 169.375C-3.125 181.875 -3.125 202.175 9.375 214.675C21.875 227.175 42.175 227.175 54.675 214.675L160.075 109.175V415.975C160.075 433.675 174.375 447.975 192.075 447.975C209.775 447.975 224.075 433.675 224.075 415.975V109.275L329.475 214.575C341.975 227.075 362.275 227.075 374.775 214.575C387.275 202.075 387.275 181.775 374.775 169.275L214.775 9.275L214.675 9.375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollUpArr);
export default __webpack_public_path__ + "static/media/scroll_up_arr.1f530096275565de6f04adbd214b5f55.svg";
export { ForwardRef as ReactComponent };